import { useAppDispatch, useAppSelector } from "@app/hooks";
import { LBtn, LModal } from "@components";
import { useApi } from "@services/useApi";
import { setAssessmentResults } from "@store/assessmentResultSlice";
import { WordResponseType } from "@store/assessmentSlice";
import { WordResponseApi } from "@store/generalTypes";
import { useState } from "react";
import { Translate } from "react-i18nify";

export const PresentTargetActions = ({ wordReponse, disbaled }: PresentTargetActionsProps): JSX.Element => {
    const [designateCorrectModal, setDesignateCorrectModal] = useState(false);
    const { loading, updateTargetResponse, getAssessmentResults, updateAssessmentResult } = useApi();
    const { assessmentResult, location } = useAppSelector((x) => {
        return { assessmentResult: x.assessmentResult, location: x.orgLocations.currentLocation };
    });
    const dispatch = useAppDispatch();

    const showCorrect =
        wordReponse.responseType === WordResponseType.Incorrect ||
        wordReponse.responseType === WordResponseType.Intrusion ||
        wordReponse.responseType === WordResponseType.OutOfScope;

    const handleOnDesignate = async (): Promise<void> => {
        if (!loading) {
            await updateTargetResponse(
                assessmentResult.id,
                wordReponse.id!,
                wordReponse.responseType === WordResponseType.Correct
                    ? WordResponseType.Incorrect
                    : WordResponseType.Correct
            ).then(async () => {
                await updateAssessmentResult(location!.id, assessmentResult.id);

                const apiAssessmentResults = await getAssessmentResults(location!.id, assessmentResult.id);
                dispatch(setAssessmentResults(apiAssessmentResults));
            });
        }
    };

    const handlerOnTriggerModal = (): void => {
        setDesignateCorrectModal(!designateCorrectModal);
    };

    return (
        <>
            <div className="present-target-actions no-wrap">
                <LBtn
                    variation="unstyled"
                    smallSpacing
                    notRounded
                    smallTopBottomMargins
                    isBold
                    fontSize="7"
                    disabled={disbaled || loading}
                    onClick={handlerOnTriggerModal}
                    loading={loading}
                >
                    {showCorrect ? (
                        <Translate value="result.designateCorrect" />
                    ) : (
                        <Translate value="result.designateIncorrect" />
                    )}
                </LBtn>
            </div>
            {designateCorrectModal && (
                <LModal
                    title={
                        <p className="has-text-weight-bold is-size-3 mx-5 has-text-centered">
                            {showCorrect ? (
                                <Translate value="result.designateCorrect" />
                            ) : (
                                <Translate value="result.designateIncorrect" />
                            )}
                        </p>
                    }
                    fullHeight={false}
                    onClose={handlerOnTriggerModal}
                    width={"s"}
                >
                    <div className="is-flex is-flex-direction-column">
                        <p className="content has-text-centered has-text-weight-bold">
                            {showCorrect ? (
                                <Translate value="result.designateCorrectTextModal" />
                            ) : (
                                <Translate value="result.designateIncorrectTextModal" />
                            )}
                        </p>
                        <p className="content has-text-centered">
                            {showCorrect ? (
                                <Translate value="result.designateCorrectDetailModal" />
                            ) : (
                                <Translate value="result.designateIncorrectDetailModal" />
                            )}
                        </p>
                        <div className="divider" />
                        <div className="pt-2">
                            <div className="columns">
                                <div className="column" />
                                <div className="column">
                                    <LBtn variation="outline" fullWidth isBold onClick={handlerOnTriggerModal}>
                                        <Translate value="cancel" />
                                    </LBtn>
                                </div>
                                <div className="column is-1" />
                                <div className="column">
                                    <LBtn fullWidth isBold onClick={handleOnDesignate} loading={loading}>
                                        {showCorrect ? (
                                            <Translate value="result.designateCorrect" />
                                        ) : (
                                            <Translate value="result.designateIncorrect" />
                                        )}
                                    </LBtn>
                                </div>
                                <div className="column" />
                            </div>
                        </div>
                    </div>
                </LModal>
            )}
        </>
    );
};

interface PresentTargetActionsProps {
    wordReponse: WordResponseApi;
    disbaled: boolean;
}
